import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { AppProviders } from '@/app/providers/AppProviders'
import AppRouter from '@/app/router/AppRouter'
import './index.css'
import './styles/theme-effects.scss'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN

const PII_KEY_PATTERN = /password|senha|cpf|token|secret|authorization|cookie|credit|card|cvv|email/i

function redactPii(value: unknown, depth = 0): void {
  if (depth > 6 || !value || typeof value !== 'object') return
  if (Array.isArray(value)) {
    for (const item of value) redactPii(item, depth + 1)
    return
  }
  const obj = value as Record<string, unknown>
  for (const key of Object.keys(obj)) {
    if (PII_KEY_PATTERN.test(key)) {
      obj[key] = '[redacted]'
    } else {
      redactPii(obj[key], depth + 1)
    }
  }
}

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.1,
    sendDefaultPii: false,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    beforeSend(event) {
      if (event.request) {
        redactPii(event.request.headers)
        redactPii(event.request.data)
        if (event.request.query_string) {
          event.request.query_string = '[redacted]'
        }
      }
      redactPii(event.extra)
      redactPii(event.contexts)
      redactPii(event.tags)
      return event
    },
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </React.StrictMode>,
)
